import { Box, styled } from '@mui/material';
import { themeColors } from 'src/theme';

export const StyledSectionBox = styled(Box)({
  width: '100%',
  backgroundColor: themeColors.grayLight,
  borderRadius: '4px 4px 0px 0px',
  padding: '24px',
});

export const ResponsiveGridBox = styled(Box)(({ theme }) => ({
  display: 'grid',
  columnGap: '12px',
  gridTemplateColumns: '1fr',

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: '1fr 1fr',
  },
}));

export const SingleColumnGridBox = styled(Box)(({ theme }) => ({
  display: 'grid',
  columnGap: '12px',
  gridTemplateColumns: '1fr',
}));

export const GridItem = styled(Box)({
  backgroundColor: '#fff',
  border: '1px solid #ddd',
  borderRadius: '8px',
  padding: '16px',
});
